export const SWITCHER_TAB_PANEL_PREFIX = 'app-switcher-tab-panel';
export const SWITCHER_TAB_BUTTON_PREFIX = 'app-switcher-tab-btn';
